import { Directive, Input } from '@angular/core';

import { Stripe } from '@df/module-stripe/stripe.namespace';
import { AbstractStripeCardComponent } from '@df/module-stripe/abstract-stripe-card.component';

import { Checkout } from '@df/checkout/checkout.interfaces';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';

@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class StripeSavedCardComponentDef extends AbstractStripeCardComponent<Stripe.ICardPaymentMethod> {
    override valid = true;

    @Input({
        required: true
    })
    card!: CreditCard;

    override ngOnInit() {
        this.subscriptions.add(
            this.events.on(Checkout.EVENTS.SavePaymentMethodBefore).subscribe((savePaymentData: Checkout.IQuoteDataPayment) => {
                if (savePaymentData.method === this.card?.code) {
                    // we don't save it
                    delete savePaymentData.method;
                }
            })
        );
    }

    /**
     * On elements object created callback
     */
    protected onElementsCreated(): void {}

    protected isComponentReady(): boolean {
        return true;
    }

    /**
     * Checks if elements can be displayed (template is correct for example)
     * @returns {boolean}
     */
    protected canDisplayElements(): boolean {
        return true;
    }

    /**
     * Checks if method is currently selected one
     * @return {boolean}
     */
    override isSelected(): boolean {
        return this.card.code === this.checkoutFormComponent.paymentMethodCode;
    }

    //////////////////////////////////////////
    /////
    /////   Checkout
    /////
    //////////////////////////////////////////

    protected getToken(): Promise<string> {
        return new Promise((resolve, reject) => {
            if (this.card?.data?.public_hash) {
                resolve(this.card.data.public_hash);
            } else {
                reject();
            }
        });
    }
}
